import { useLazyQuery } from '@apollo/client'

import { GetProductModalSupplierDetailsDocument } from '@/graphql/purchase-plus/generated/getProductModalSupplierDetails.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetProductModalSupplierDetailsProps {
  tradeRelationshipId: number
}

export const useGetProductModalSupplierDetails = ({ tradeRelationshipId }: UseGetProductModalSupplierDetailsProps) => {
  const [fetchProductModalSupplierDetails, { data, networkStatus, error, refetch }] = useLazyQuery(
    GetProductModalSupplierDetailsDocument,
    {
      variables: {
        tradeRelationshipId,
      },
      context: {
        uri: PURCHASE_PLUS_GRAPHQL_API,
      },
      notifyOnNetworkStatusChange: true,
    }
  )

  const supplier = data?.tradeRelationship?.supplier

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    fetchProductModalSupplierDetails,
    error,
    supplier,
    loadingStates,
    refetch,
  }
}
